import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { PayoutSettingsRouter } from "./Router";

export function PayoutSettingsContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <PayoutSettingsRouter />
    </ThemeProvider>
  );
}
